import { render, staticRenderFns } from "./v20a2000.vue?vue&type=template&id=f4de5d84&"
import script from "./v20a2000.vue?vue&type=script&lang=js&"
export * from "./v20a2000.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports